<script>
  import FetchController from './FetchController.vue';
  export default {
    extends: FetchController,
    methods: {
      submitAccount(roleId, firstName, lastName, steamHex, username, password, job) {
        return this.fetchData('/users/create', 'POST', {roleId, firstName, lastName, steamHex, username, password, job}, true, false)
          .then(res => {
            return res.json();
          })
          .then(data => {
            return data;
          })

      }
    }
  }
</script>